/**
 * Reusable message display component for success/error messages
 * Used across multiple pages for consistent message styling
 */
const MessageDisplay = ({ message, error, success, className = '', id }) => {
  // Support both old format (message prop) and new format (error/success props)
  const displayMessage = error || success || message;
  if (!displayMessage) return null;

  const isError = !!error || (message && message.startsWith('❌'));
  
  return (
    <div
      id={id}
      className={`mb-6 p-4 rounded-lg text-sm text-center whitespace-pre-line scroll-mt-28 ${className}`}
    >
      {isError ? (
        <div className="p-3 rounded-lg" style={{ 
          backgroundColor: 'var(--color-error-50)',
          border: '1px solid var(--color-error-200)',
          color: 'var(--color-error-700)'
        }}>
          {displayMessage}
        </div>
      ) : (
        <div className="p-3 rounded-lg" style={{ 
          backgroundColor: 'var(--color-success-50)',
          border: '1px solid var(--color-success-200)',
          color: 'var(--color-success-700)'
        }}>
          {displayMessage}
        </div>
      )}
    </div>
  );
};

export default MessageDisplay;



